export const apiUrl = "https://mnaleisureapi.waepos.com/";
export const adminUrl = "https://mnaleisureadmin.waepos.com/";
